import { useState, useEffect } from 'react'

export function usePersistState(key, initialValue) {
    const [state, setState] = useState(() => {
        const storedValue = localStorage.getItem(key)
        try {
            return storedValue ? JSON.parse(storedValue) : initialValue
        } catch (error) {
            console.warn(`Error reading localStorage key "${key}":`, error);
            // If parsing fails (e.g. raw string "light"), return the raw value if it exists, else initialValue
            return storedValue || initialValue;
        }
    })

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state))
    }, [key, state])

    return [state, setState]
}
